import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import Footer from '../elements/Footer';
import Accordion from 'react-bootstrap/Accordion';




function Servicebusinessformation() {
  return (
    <div className='Business-formation'>
        <div className="">
            <Header/>
            <main>
                <Breadcrumb title="Business Formation" sub_title="Service" active="Business Formation"/>
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                            <div className="tmp-large-service-detials">
                                <img
                                src="assets/images/services/business-formation-service.jpg"
                                alt="business formation"
                                />
                            </div>
                            {/* single service details component */}
                            <div className="single-service-details-component mt--40">
                                <h2 className="title split-collab">
                                Start Strong with Personalized Business Formation Services
                                </h2>
                                <p className="disc mb--20">
                                Let us help turn your vision to reality. We are proud to offer personalized business formation services tailored to meet your unique needs. We have helped companies form sole proprietorship, LLC’s and corporations and guided them in selecting the best business structure to file.
                                </p>
                                <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Instant Business Growth</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Expert Team Members</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    {/* chck-area-wrapper */}
                                    <div className="check-service-wrapper">
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>Easy Customer Service</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-circle-check" />
                                        <p>24/7 Quality Service</p>
                                    </div>
                                    </div>
                                    {/* chck-area-wrapper end */}
                                </div>
                                </div>
                            </div>
                            {/* single service details component end */}
                            <div className="row g-5 mt--10">
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Comprehensive Business Formation Services</h6>
                                    <p className="disc">
                                        We can handle every step of the business formation process, starting with name registration and reservation to ensure your chosen name is secured. Our team prepares all necessary formation documents on your behalf, ensuring accuracy and compliance with state requirements. We also obtain your Federal Employer Identification Number (EIN) for opening bank accounts, hiring employees and meeting tax obligations.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                                <div className="col-lg-6 col-md-6">
                                {/* single service large-details */}
                                <div className="single-service-details">
                                    
                                    <div className="information">
                                    <h6 className="title">Ensure Compliance with the Right Permits and Licenses</h6>
                                    <p className="disc">
                                        Avoid costly delays and penalties by letting us guide you through identifying and obtaining the specific permits and licenses required for your industry and location. We help you stay fully compliant from the start, so you can launch and operate your business with confidence.
                                    </p>
                                    </div>
                                </div>
                                {/* single service large-details end */}
                                </div>
                            </div>
                            <div className="row g-5 mt--10">
                                <div className="col-lg-12">
                                <h2 className="title split-collab">Strategic Entity Selection Tailored to Your Goals</h2>
                                <p className="disc mb--20">
                                    We assist you in selecting the right business entity by helping you choose the most appropriate legal structure based on your unique goals, industry and operational needs. Choosing the right business entity is a critical step that affects your taxes, liability and ability to raise capital. We help you understand the pros and cons of each option so you can make an informed decision.
                                </p>
                                </div>
                                
                                
                                
                            </div>
                            <div className="row mt--10">
                                <div className="col-lg-12">
                                <div className="faq-accordion">

                                    <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                        <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>What is included in your business formation service?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                                </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Our business formation service covers everything from registering your business name and preparing legal documents to obtaining tax IDs and ensuring compliance with state and federal requirements. We handle the paperwork so you can focus on launching your venture confidently.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>How long does it take to form a business?</span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                               The timeline depends on your state and entity type (LLC, Corporation, etc.), but most formations are completed within 3 to 10 business days. We’ll keep you updated throughout the process to ensure a smooth and timely setup.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            <div className="accordion-button-left">
                                                <i className="fa-regular fa-question" />
                                                <span>
                                                    Do you provide guidance on choosing the right business structure?
                                                </span>
                                                </div>
                                                <div className="accordion-button-right">
                                                <i className="fa-sharp fa-light fa-arrow-right" />
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                                Yes! Our experts help you determine whether an LLC, Corporation, or Partnership best suits your goals, tax situation, and growth plans. We make sure your structure supports both legal protection and financial efficiency.
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    </Accordion>

                                    <div className="faq-buttom">
                                    <h4 className="title">Still Have More Questions?</h4>
                                    <p>
                                                      Contact Our <a style={{color:"#F8E3E3"}} href="/contact-us">Expert Support Team</a>
                                    </p>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>
                            <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                            <div className="side-bar-details-page">
                                
                                {/* single bar */}
                                <div className="signle-side-bar category-area">
                                <div className="header">
                                    <h3 className="title">Service List</h3>
                                </div>
                                <div className="body">
                                    {/* single category */}
                                    <a href="/payroll-management" className="single-category">
                                    <p>Payroll Management</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/book-keeping" className="single-category">
                                    <p>Book Keeping</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/tax" className="single-category">
                                    <p>Tax</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    {/* single category */}
                                    <a href="/business-consultation" className="single-category">
                                    <p>Business Consultation</p>
                                    <i className="fa-light fa-arrow-right" />
                                    </a>
                                    {/* single category end */}
                                    
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                <div className="signle-side-bar call-to-action">
                                <div className="easy-call-to-action">
                                    <div className="icon-center-call">
                                    <i className="fa-light fa-phone" />
                                    </div>
                                    <h3 className="title">Need any help?</h3>
                                    <p className="disc">
                                    We are here to help our customer any time. You can call on
                                    24/7 To Answer Your Question.
                                    </p>
                                    <a href="tel:8323510418">832-351-0418</a>
                                </div>
                                </div>
                                {/* single bar end */}
                                {/* single bar */}
                                {/* <div className="signle-side-bar brochure">
                                <div className="header">
                                    <h3 className="title">Brochure</h3>
                                </div>
                                <div className="body">
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Investment Policy</p>
                                    <i className="fa-light fa-cloud-arrow-down" />
                                    </a>
                                    
                                    <a href="#" className="single-brocher">
                                    <p>Company Details</p>
                                    <i className="fa-light fa-note" />
                                    </a>
                                  
                                </div>
                                </div> */}
                                {/* single bar end */}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                <Footer/>
            </main>
        </div>
    </div>
  )
}

export default Servicebusinessformation